(function () {
  const fees = (method, subtotal) => {
    const shipping = subtotal >= 1099900 ? 0 : 85000;
    const total = method === 'cod' ? subtotal >= 1099900 ? 60000 : subtotal >= 880000 ? 139900 : subtotal >= 500000 ? 119900 : 99900 : shipping;
    return { shipping, handling: method === 'cod' ? total - shipping : 0, total };
  };
  const money = cents => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(cents / 100);
  const discountCodes = cart => {
    const codes = [];
    for (const entry of cart.discount_codes || []) if (typeof entry === 'string') codes.push(entry); else if (entry.applicable !== false && entry.code) codes.push(entry.code);
    const applications = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    for (const app of applications) if (app?.type === 'discount_code') codes.push(app.title);
    return [...new Set(codes.filter(Boolean))];
  };
  const freeShipping = amount => {
    const merchandise = Number.isFinite(Number(amount)) ? Math.max(0, Number(amount)) : 0;
    return { remaining: Math.max(0, 1099900 - merchandise), progress: Math.min(100, merchandise / 1099900 * 100) };
  };
  window.tiiCartPricing = { fees, discountCodes, freeShipping };
  const storageKey = 'tii_cart_delivery_method';
  const getSaved = () => { try { return sessionStorage.getItem(storageKey); } catch (_) { return null; } };
  const save = method => { try { sessionStorage.setItem(storageKey, method); } catch (_) {} };
  const update = () => {
    const summary = document.querySelector('[data-cart-pricing]');
    try {
      const message = sessionStorage.getItem('tii_cart_discount_error');
      const error = document.querySelector('[data-cart-discount-error]');
      if (message && error) { error.hidden = false; error.textContent = message; sessionStorage.removeItem('tii_cart_discount_error'); }
    } catch (_) {}
    if (!summary) return;
    const saved = getSaved();
    if (!summary.querySelector('[data-cart-delivery-method]:checked') && ['cod', 'card'].includes(saved)) {
      for (const input of summary.querySelectorAll('[data-cart-delivery-method]')) input.checked = input.value === saved;
    }
    const subtotal = Number(summary.dataset.cartTotal);
    const codInput = summary.querySelector('[data-cart-delivery-method][value="cod"]');
    if (codInput) {
      const unavailable = subtotal > 1200000;
      codInput.closest('.cart-pricing__option').hidden = unavailable;
      codInput.disabled = unavailable;
      if (unavailable) {
        codInput.checked = false;
        const cardInput = summary.querySelector('[data-cart-delivery-method][value="card"]');
        if (cardInput) cardInput.checked = true;
      }
    }
    const shippingStatus = freeShipping(subtotal);
    const message = summary.querySelector('[data-cart-free-shipping-message]');
    if (message) {
      if (!shippingStatus.remaining) message.textContent = '✓ このご注文は送料無料です';
      else message.innerHTML = `あと <strong>${new Intl.NumberFormat('ja-JP').format(shippingStatus.remaining / 100)}円</strong><strong>送料無料</strong>`;
      summary.querySelector('[data-cart-free-shipping-fill]').style.width = `${shippingStatus.progress}%`;
      summary.querySelector('[data-cart-free-shipping-progress]').setAttribute('aria-valuenow', String(shippingStatus.progress));
      summary.querySelector('[data-cart-free-shipping-progress]').style.setProperty('--shipping-progress', `${shippingStatus.progress}%`);
      summary.querySelector('[data-cart-free-shipping-help]').hidden = !shippingStatus.remaining;
      summary.querySelector('[data-cart-base-shipping]').hidden = !shippingStatus.remaining;
    }
    for (const method of ['cod', 'card']) {
      const fee = fees(method, subtotal);
      summary.querySelector(`[data-cart-method-price="${method}"]`).textContent = money(fee.total);
      summary.querySelector(`[data-cart-method-description="${method}"]`).textContent = method === 'cod'
        ? fee.shipping ? `送料850円＋代引手数料${fee.handling / 100}円` : `送料無料＋代引手数料${fee.handling / 100}円`
        : fee.shipping ? 'クレジットカード決済・送料850円' : 'クレジットカード決済・送料無料';
    }
    const method = summary.querySelector('[data-cart-delivery-method]:checked')?.value;
    if (method) save(method);
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-delivery-method]')) {
      save(event.target.value);
      window.tiiCheckoutAnalytics?.track('cart_delivery_select', { delivery_method: event.target.value });
      event.target.closest('[data-cart-pricing]').querySelector('[data-cart-method-error]').hidden = true;
      update();
    }
  });
  document.addEventListener('click', async event => {
    const discountToggle = event.target.closest('[data-cart-discount-toggle]');
    if (discountToggle) {
      window.tiiCheckoutAnalytics?.track('cod_discount_open');
      const summary = discountToggle.closest('[data-cart-discount-scope]');
      summary.querySelector('[data-cart-discount-fields]').hidden = false;
      discountToggle.setAttribute('aria-expanded', 'true');
      discountToggle.hidden = true;
      summary.querySelector('[data-cart-discount-input]').focus();
      return;
    }
    const discountButton = event.target.closest('[data-cart-discount-apply]');
    if (discountButton) {
      const summary = discountButton.closest('[data-cart-discount-scope]');
      const error = summary.querySelector('[data-cart-discount-error]');
      const requested = summary.querySelector('[data-cart-discount-input]').value.split(',').map(code => code.trim()).filter(Boolean);
      discountButton.disabled = true; error.hidden = true;
      window.tiiCheckoutAnalytics?.track('cod_discount_apply');
      try {
        const response = await fetch(`${window.routes.cart_url}/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: requested.join(',') }) });
        const cart = await response.json();
        if (!response.ok) throw new Error('discount update failed');
        const applied = discountCodes(cart).map(code => code.toUpperCase());
        window.tiiCheckoutAnalytics?.track('cod_discount_result', { result: !requested.length ? 'cleared' : requested.some(code => !applied.includes(code.toUpperCase())) ? 'rejected' : 'success' });
        if (requested.some(code => !applied.includes(code.toUpperCase()))) try { sessionStorage.setItem('tii_cart_discount_error', '適用できない割引コードがあります。'); } catch (_) {}
        window.location.reload();
      } catch (_) { window.tiiCheckoutAnalytics?.track('cod_discount_result', { result: 'failed' }); error.textContent = '割引コードを適用できませんでした。再度お試しください。'; error.hidden = false; discountButton.disabled = false; }
      return;
    }
    if (!event.target.closest('#checkout') || !document.querySelector('[data-cart-pricing]')) return;
    event.preventDefault();
    const summary = document.querySelector('[data-cart-pricing]');
    if (Number(summary.dataset.itemCount) < 1) return;
    const method = summary.querySelector('[data-cart-delivery-method]:checked')?.value;
    const error = summary.querySelector('[data-cart-method-error]');
    if (!method) { window.tiiCheckoutAnalytics?.track('cart_selection_error'); error.hidden = false; summary.querySelector('[data-cart-delivery-method]').focus(); return; }
    if (method === 'cod' && Number(summary.dataset.cartTotal) > 1200000) { update(); return; }
    error.hidden = true; save(method);
    if (method === 'cod') {
      const fee = fees('cod', Number(summary.dataset.cartTotal));
      try { sessionStorage.setItem('tii_cod_cart_amounts', JSON.stringify({ merchandise: Number(summary.dataset.cartTotal), shipping: fee.shipping, handling: fee.handling, total: Number(summary.dataset.cartTotal) + fee.total })); } catch (_) {}
    }
    window.tiiCheckoutAnalytics?.track('cart_continue', { delivery_method: method, merchandise_value: Number(summary.dataset.cartTotal) / 100, currency: 'JPY' });
    window.location.assign(method === 'cod' ? '/pages/delivery-information' : '/checkout');
  });
  update();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, update);
  if (typeof MutationObserver !== 'undefined') new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1
      && (node.matches('[data-cart-pricing]') || node.querySelector('[data-cart-pricing]'))))) update();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
